// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__3aHzw","faq__inner":"FAQ_faq__inner__22in9"};